import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import GetTransformedDate from "utils/dateViewTransformer.tsx";
import useMediaQueries from "hooks/useMediaQueries.js";

const BlackFridayPromoElemTooltip = ({ hovered, withHover, number }) => {
  const {
    getBlackFridayTime,
    getTextByKey,
    replaceKeywordsInText,
    getHtmlByKey,
  } = useContent();

  const ref = useRef(null);

  const { mobileCondition } = useMediaQueries();

  const date = new Date(
    getBlackFridayTime() * 1000 + new Date().getTime()
  ).toISOString();
  const transformedDate = GetTransformedDate({ date });

  useEffect(() => {
    if (ref.current) {
      const elemPosition = ref.current.getBoundingClientRect();
      const elemRight = elemPosition.right;
      const windowWidth = window.innerWidth;
      if (windowWidth < elemRight) {
        ref.current.style.left = "auto";
        ref.current.style.right = "72px";
      }
    }
  }, [hovered]);

  return hovered && withHover && !mobileCondition ? (
    <div className="blackfriday-promo-elem-tooltip" ref={ref}>
      <div className="bf-promor-circle-tooltip-title">
        {getTextByKey("hp-promo-title")}
      </div>
      <div className="bf-promor-circle-tooltip-subtitle">
        {replaceKeywordsInText(
          getHtmlByKey("hp-promo-subtitle"),
          ["#number#"],
          [number]
        )}
      </div>
      <div className="bf-promo-circle-tooltip-text">
        {replaceKeywordsInText(
          getHtmlByKey("hp-promo-text-three"),
          ["#date#"],
          [transformedDate]
        )}
      </div>
    </div>
  ) : null;
};

const BlackFridayPromoElem = ({ withHover, number }) => {
  const { getBlackFridayTime } = useContent();

  const [hovered, setHovered] = useState(false);

  return getBlackFridayTime() ? (
    <div
      className="black-friday-promo-elem"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      -{number}%
      <BlackFridayPromoElemTooltip
        hovered={hovered}
        withHover={withHover}
        number={number}
      />
    </div>
  ) : null;
};
export default BlackFridayPromoElem;
